// extracted by mini-css-extract-plugin
export var pill = "pill-module--pill--35843";
export var pill__btn = "pill-module--pill__btn--bcda1";
export var pill__container = "pill-module--pill__container--96719";
export var pill__ourThemes = "pill-module--pill__our-themes--32475";
export var pill__ourThemesItem = "pill-module--pill__our-themes-item--50406";